import Image from 'next/image';
import PropTypes from 'prop-types';
import styles from './styles';

const PcModelOptionImage = ({ src, alt, width, height }) => (
  <>
    <div className="option-image">
      <Image draggable={false} src={src} alt={alt} height={height} width={width} />
    </div>

    <style jsx>{styles}</style>
  </>
);

PcModelOptionImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};

PcModelOptionImage.defaultProps = {
  src: 'https://cdn.shopify.com/s/files/1/0637/0407/2436/files/image-placeholder.png?v=1714058007',
  alt: 'Component Image',
  height: 300,
  width: 300
};

export default PcModelOptionImage;
